// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { ErrorFlagRenderer } from '@jira/platform__error-flag-renderer/src/ErrorBoundaryFlag.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { initEntryPointConfig as initPlatformEntryPointConfig } from '@atlassian/entry-point-config/init-entry-point-config';
import type {
	PlaceholderComponentProps,
	ModalErrorFallbackProps,
} from '@atlassian/entry-point-config/types';

const GlobalModalErrorFallback = ({ error, closeModal }: ModalErrorFallbackProps) => {
	// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent -- only the error boundary fallback knows the modal content failed to render, so the close must be requested from here
	useEffect(() => {
		closeModal();
	}, [closeModal]);

	return <ErrorFlagRenderer id="" error={error} />;
};

export function initEntryPointConfig(): void {
	initPlatformEntryPointConfig({
		PlaceholderComponent: ({ name, ...props }: PlaceholderComponentProps) => (
			<Placeholder name={name || ''} {...props} />
		),
		UFOSegmentComponent: UFOSegment,
		GlobalModalErrorFallback,
	});
}
